// extracted by mini-css-extract-plugin
export default {"pendingBar":"style_pendingBar__TFjfa","completedPrecentage":"style_completedPrecentage__IHf65","growWidth":"style_growWidth__pIbBx"};